import React from 'react';
import Img from 'gatsby-image';
import { Container } from 'library';
import { take } from 'lodash';

import './ThreeImageBlock.scss';

const ThreeImageBlock = ({ images = [] }) => {
  const limitedImages = take(images, 3);
  return (
    <div className="ThreeImageBlock">
      <Container row align="center">
        {limitedImages.map((img) => {
          return (
            <Container grid={4} className="ThreeImageBlockImgWrap" key={img.sourceUrl}>
              {img?.localFile?.childImageSharp?.fluid ? (
                <Img fluid={img.localFile.childImageSharp.fluid} alt={img.altText} style={{ width: '100%' }} />
              ) : (
                <img src={img.sourceUrl} alt={img.altText} />
              )}
            </Container>
          );
        })}
      </Container>
    </div>
  );
};

export default ThreeImageBlock;
